import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styles from './ChangePasswordCard.module.css';
export function ChangePasswordCard({ onChangePassword }) {
    const [current, setCurrent] = useState('');
    const [next, setNext] = useState('');
    const [confirm, setConfirm] = useState('');
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const submit = async () => {
        if (!current || !next) {
            setError('Aktuelles und neues Passwort eingeben.');
            return;
        }
        if (next.length < 8) {
            setError('Das neue Passwort muss mindestens 8 Zeichen lang sein.');
            return;
        }
        if (next !== confirm) {
            setError('Neue Passwörter stimmen nicht überein.');
            return;
        }
        setSubmitting(true);
        setError(null);
        try {
            await onChangePassword(current, next);
            setCurrent('');
            setNext('');
            setConfirm('');
        }
        catch (e) {
            setError(e instanceof Error ? e.message : 'Passwort konnte nicht geändert werden.');
        }
        finally {
            setSubmitting(false);
        }
    };
    return (_jsxs("div", { className: styles.card, children: [_jsx("div", { className: styles.groupTitle, children: "Konto" }), _jsx("label", { className: styles.label, children: "Aktuelles Passwort" }), _jsx("input", { type: "password", value: current, onChange: e => {
                    setCurrent(e.target.value);
                    setError(null);
                }, autoComplete: "current-password", className: styles.input }), _jsx("label", { className: styles.label, children: "Neues Passwort" }), _jsx("input", { type: "password", value: next, onChange: e => {
                    setNext(e.target.value);
                    setError(null);
                }, autoComplete: "new-password", className: styles.input }), _jsx("label", { className: styles.label, children: "Neues Passwort best\u00E4tigen" }), _jsx("input", { type: "password", value: confirm, onChange: e => {
                    setConfirm(e.target.value);
                    setError(null);
                }, onKeyDown: e => {
                    if (e.key === 'Enter')
                        void submit();
                }, autoComplete: "new-password", className: styles.input }), error && _jsx("div", { className: styles.error, children: error }), _jsx("button", { type: "button", onClick: () => void submit(), disabled: submitting, className: styles.submit, children: "Passwort \u00E4ndern" })] }));
}
